<template>
  <el-table :data="table" height="240" style="width: 100%">
    <el-table-column prop="公司名称" label="公司名称">
      <template slot-scope="scope">
        <span style="color:#409eff;cursor:pointer;" @click="showcompany(scope.row.公司名称)">{{
          scope.row.公司名称
        }}</span>
      </template>
    </el-table-column>
    <el-table-column prop="日期" label="日期"> </el-table-column>
  </el-table>
</template>
<script>
export default {
  props: {
    table: { type: Array, default: () => [] },
  },
  data() {
    return {}
  },
  methods: {
    showcompany(val) {
      app.root.search({ type: '公司', keywords: val })
    },
  },
}
</script>
